export const BREADCRUMB_LIST = [
  { id: "1", title: "Pedidos", active: false },
  { id: "2", title: "Crear Pedidos", active: true },
]

export const MAX_RATING = 3

export const SAVED_FEEDBACK_MS = 3000

// Corte de las 19:00: solo aplica a la entrega con flete. Si se recoge en granja
// no hay ruta que respetar y el horario se abre desde la hora actual.
export const CUTOFF_TIME = "19:00"

export const DAY_START_TIME = "00:00"

// Granularidad de los horarios de recepción ofrecidos, en minutos.
export const TIME_STEP_MINUTES = 30

export const MESES = [
  "ENERO",
  "FEBRERO",
  "MARZO",
  "ABRIL",
  "MAYO",
  "JUNIO",
  "JULIO",
  "AGOSTO",
  "SEPTIEMBRE",
  "OCTUBRE",
  "NOVIEMBRE",
  "DICIEMBRE",
]
